module.exports = __webpack_public_path__ + "static/media/squadeal.c4e85b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/squadeal/squadeal.png
// module id = 40
// module chunks = 0